import React, { useEffect } from "react";
// import { Player } from "@lottiefiles/react-lottie-player";
// import confettiAnim from "./confetti.json";
// // import { requireAsset } from "../utils/asset";

export default function BlockCompletePopup({ visible, onClose }) {
  useEffect(() => {
    if (!visible) return;

    const t = setTimeout(() => {
      if (onClose) onClose();
    }, 1500);

    return () => clearTimeout(t);
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center pointer-events-none">
      <div className="relative flex items-center justify-center">
        <div className="absolute w-16 h-16 rounded-full bg-accent/20 animate-pingSlow"></div>
        <div className="relative bg-white shadow-xl rounded-full w-28 h-28 flex items-center justify-center animate-scaleInOut">
          <span className="text-4xl text-accent animate-rotateSlow">⚙️</span>
        </div>
      </div>
    </div>
  );
}
